import React from 'react'
//import ChatBotLogo from "../../images/chat-bot.svg"
import "./Chatbot.scss"
import ZohoChat from '../../ZohoChat';


const Chatbot = ({position}) => {
    return (
        <div className={position ? "chatbot-up chatbot" : "chatbot"}>
           <ZohoChat />
        </div>
    )
};

export default Chatbot;
